import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { AbIfDirective } from '@df/module-ab/ab-if.directive';
import { Ab } from '@df/module-ab/ab.namespace';
import { AbService } from '@df/module-ab/ab.service';
import { AB_OPTIONS } from './ab.tokens';

@NgModule({
    imports: [AbIfDirective],
    exports: [AbIfDirective]
})
export class AbModule {
    static forRoot(options?: Partial<Ab.IOptions>): ModuleWithProviders<AbModule> {
        return {
            ngModule: AbModule,
            providers: [
                {
                    provide: AB_OPTIONS,
                    useValue: options
                },
                {
                    provide: APP_INITIALIZER,
                    useFactory: (abService: AbService) => () => {
                        abService.appInitialize();
                    },
                    deps: [AbService],
                    multi: true
                }
            ]
        };
    }
}
